import { AnyAction } from 'redux';
import {
  ANZAHL_TAGE_TIER_ZU_JUNG,
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  isTierZuJungByToday,
  TierartEnum,
  TkvVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import {
  GlobalActions,
  TARIF_CHECKED,
  VereinbarungenChanged,
  VorbelegungPayload,
  VorversicherungChanged,
} from '@ps20-frontend/shop-integration-redux';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';
import { convertFromBffTierart } from './versicherungsnehmer.reducer';

export function mapTierartAufSelbstbeteiligung(tierart: TierartEnum): Selbstbeteiligung {
  return {
    [TierartEnum.HUND]: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT,
    [TierartEnum.KATZE]: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT,
    [TierartEnum.PFERD]: Selbstbeteiligung.SELBSTBETEILIGUNG_20_PROZENT,
  }[tierart];
}

function determineBeginnDatumByGeburtsdatumTier(geburtsdatumTier: string): string {
  if (isTierZuJungByToday(geburtsdatumTier, DATEFORMAT_LOCAL_STATE)) {
    return dayjs(geburtsdatumTier, DATEFORMAT_LOCAL_STATE)
      .add(ANZAHL_TAGE_TIER_ZU_JUNG, 'day')
      .format(DATEFORMAT_LOCAL_STATE);
  }
  return dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE);
}

export const tkvVertragsoptionenReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.TKV, state) as Vertragsoptionen;
  switch (action.type) {
    case TkvActions.TKV_TIERART_CHANGED: {
      const selbstbeteiligung: Selbstbeteiligung = mapTierartAufSelbstbeteiligung(action.payload);
      return { ...sectionState, selbstbeteiligung };
    }
    case TkvActions.VORBELEGUNG_FOR_TKV_ERSATZ_REQUESTED: {
      if (action.payload.tierart) {
        const selbstbeteiligung: Selbstbeteiligung = mapTierartAufSelbstbeteiligung(
          convertFromBffTierart(action.payload.tierart),
        );
        return {
          ...sectionState,
          selbstbeteiligung,
          urbeginn: action.payload.urbeginn,
        };
      }
      return sectionState;
    }
    case TkvActions.SELBSTBETEILIGUNG_CHANGED: {
      const selbstbeteiligung: Selbstbeteiligung = action.payload;
      return { ...sectionState, selbstbeteiligung };
    }
    case TkvActions.GEBURTSDATUM_TIER_CHANGED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      newState.beginnDatum = determineBeginnDatumByGeburtsdatumTier(action.payload);
      return newState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: TkvVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.TKV && actionPayload.angebotsId === state.angebotsId) {
        return {
          ...getVetragsOptionenFromVorvertrag(sectionState, actionPayload),
        };
      }
      return sectionState;
    }
    case GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED: {
      const actionPayload: VorversicherungChanged = action.payload;
      const { appId, angebotsId } = actionPayload;
      if (appId === App.TKV && angebotsId === state.angebotsId) {
        return {
          ...sectionState,
          vorversicherungVorhanden: actionPayload.vorhanden,
        };
      }
      return sectionState;
    }
    case TARIF_CHECKED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      determineLaufzeit(action, newState, state.produkt, sectionState);
      return newState;
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.TKV, state.angebotsId);
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      const newState: Vertragsoptionen = cloneDeep(sectionState);
      const actionPayload: VereinbarungenChanged = action.payload;
      const kuendigungenPayload = actionPayload.kuendingungChanged.some(elem => {
        return elem.appId === App.TKV && elem.angebotsId === state.angebotsId;
      });
      if (kuendigungenPayload) {
        newState.vorvertragGekuendigt = true;
      }
      return newState;
    }
    case GlobalActions.VORBELEGUNG_FINISHED: {
      const actionPayload: VorbelegungPayload = action.payload;
      const { appId, angebotsId } = actionPayload;
      if (appId === App.TKV && angebotsId === state.angebotsId) {
        const tkvVorbelegungdaten: TkvVorbelegungdaten =
          actionPayload.vorhandeneVorbelegungdaten as TkvVorbelegungdaten;
        return {
          ...sectionState,
          urbeginn: tkvVorbelegungdaten.urbeginn,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
